import { useCallback, useContext } from 'react';
import { GrippContext } from '../grippContext';

/**
 * Asks whether the session may drop or swap its account. Resolves true
 * straight away where nothing is injected (web) or nothing is unsynced; false
 * means the user chose to stay, and the caller must not go on.
 */
export const useUnsyncedWorkGuard = () => {
  const outbox = useContext(GrippContext)?.outbox;
  return useCallback(
    async (): Promise<boolean> => (outbox ? outbox.confirmLeave() : true),
    [outbox]
  );
};
